// Calls that share a key run one after another, in call order. Use it for saves that
// overwrite each other, so the last call made is also the last one stored.
const tails = new Map<string, Promise<unknown>>()

export function serializeByKey<T>(key: string, task: () => Promise<T>): Promise<T> {
  const run = (tails.get(key) ?? Promise.resolve()).catch(() => {}).then(task)
  tails.set(key, run)
  run.finally(() => { if (tails.get(key) === run) tails.delete(key) }).catch(() => {})
  return run
}
